import script from "./FilterComenzi.vue?vue&type=script&lang=ts&setup=true"
export * from "./FilterComenzi.vue?vue&type=script&lang=ts&setup=true"

import "./FilterComenzi.vue?vue&type=style&index=0&id=2fd8b8ec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fd8b8ec"]])

export default __exports__